import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MatButtonModule} from "@angular/material/button";
import {MatListModule} from "@angular/material/list";
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {SnackbarService} from "../../../services/snackbar.service";
import {MatIconModule} from "@angular/material/icon";
import {PutFeedbackRequest} from "scribe-poc-shared";
import {HttpClient} from "@angular/common/http";
import {AppointmentService} from "../../../services/appointment.service";
import {firstValueFrom} from "rxjs";
import {environment} from "../../../../environments/environment";

/** Show the feedback dialog */
@Component({
	selector: 'feedback-dialog',
	imports: [
		MatDialogModule,
		MatButtonModule,
		MatListModule,
		ReactiveFormsModule,
		MatIconModule,
		FormsModule
	],
	templateUrl: './feedback-dialog.component.html',
	styleUrl: './feedback-dialog.scss'
})
export class FeedbackDialogComponent implements OnInit {
	/** The form for the feedback */
	form = new FormGroup({
		selectedId: new FormControl('', [Validators.required]),
		message: new FormControl('')
	})

	messageHeader:string;

	/** All the issues */
	options:FeedbackRow[] = [];

	private appointmentId:string;

	constructor(@Inject(MAT_DIALOG_DATA) public data:{ type:FeedbackType, code?:string },
	            private appointmentService:AppointmentService,
	            private snackbarService:SnackbarService,
	            private dialogRef:MatDialogRef<FeedbackDialogComponent>,
	            private http:HttpClient) {
	}

	ngOnInit():void {
		this.messageHeader = this.data.type == 'CODE'
			? 'What is wrong with this Code?'
			: 'What is wrong with this Note?';

		this.appointmentId = this.appointmentService.current.appointment.id;

		for(const [id, issue] of this.data.type == 'CODE' ? Object.entries(CodeIssue) : Object.entries(NoteIssue)) {
			this.options.push({id, issue});
		}
	}

	async onSubmit() {
		if(this.form.valid) {

			// create the feedback request
			const feedbackRequest:PutFeedbackRequest = {
				appointmentId: this.appointmentId,
				type: this.data.type,
				id: this.form.controls.selectedId.value,
				message: this.form.controls.message.value,
				url: window.location.href,
				timestamp: new Date().getTime()
			};

			// save the feedback to Dynamo
			await firstValueFrom(this.http.put<any>(`${environment.apiUrl}/feedback/add`, feedbackRequest));

			this.snackbarService.message("Thanks! We've received your feedback.");
			this.dialogRef.close();
		}
	}
}

// noinspection JSUnusedGlobalSymbols
enum NoteIssue {
	INCORRECT_INFO = "Information is missing",
	MISSING_CONTENT = "Incorrect or irrelevant content",
	FORMATTING_ISSUE = "Formatting or vocabulary",
	OTHER = "Other"
}

// noinspection JSUnusedGlobalSymbols
enum CodeIssue {
	INCORRECT_CODE = "Incorrect code",
	MISSING_CODE = "Missing code",
	UNCLEAR_JUSTIFICATION = "Unclear or incorrect justification",
	OTHER = "Other"
}

/** Row in the selection list */
interface FeedbackRow {
	/** ID of the issue */
	id:string;

	/** Issue text */
	issue:string;
}

/** The type of feedback to return */
export type FeedbackType = "CODE" | "NOTE";
